/**
 * 404 Not Found Page
 */

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/shared/components/Button';
import styles from './NotFound.module.css';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>{t('pages.notFound.title')}</h1>
        <h2 className={styles.subtitle}>{t('pages.notFound.subtitle')}</h2>
        <p className={styles.message}>
          {t('pages.notFound.message')}
        </p>
        <div className={styles.actions}>
          <Button asChild variant="default">
            <Link to="/dashboard">
              <Home size={18} />
              {t('pages.notFound.goToDashboard')}
            </Link>
          </Button>
          <Button variant="outline" onClick={() => window.history.back()}>
            <ArrowLeft size={18} />
            {t('pages.notFound.goBack')}
          </Button>
        </div>
      </div>
    </div>
  );
}

